import React from 'react';
import { Helmet } from 'react-helmet-async';

const BreadcrumbSchema = ({ currentPage, path }) => {
  const breadcrumbList = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://bravoaustinpt.com/"
      }
    ]
  };

  // Add the current page if it's not the home page
  if (currentPage && currentPage !== "Home") {
    breadcrumbList.itemListElement.push({
      "@type": "ListItem",
      "position": 2,
      "name": currentPage,
      "item": `https://bravoaustinpt.com${path}`
    });
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbList)}
      </script>
    </Helmet>
  );
};

export default BreadcrumbSchema;
